export default __webpack_public_path__ + "static/media/Icon_No.e8ebeae8.svg";